
export default function StorySection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Our Story
            </h2>
            <div className="space-y-6 text-lg text-gray-600">
              <p>
                Cofunnels was born from a simple observation: too many businesses were struggling to convert their website visitors into customers. Despite having great products and services, they were losing potential revenue due to poor funnel design and optimization.
              </p>
              <p>
                Founded in 2019, we started as a small team of conversion specialists and grew into a trusted partner for hundreds of businesses worldwide. Our mission has always been clear: create high-converting sales funnels that transform visitors into loyal customers.
              </p>
              <p>
                Today, we've helped generate over $50 million in revenue for our clients through strategically designed funnels that convert at industry-leading rates. Every project we take on is an opportunity to make a real impact on a business's growth trajectory.
              </p>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20office%20workspace%20with%20team%20collaboration%2C%20laptops%20and%20planning%20boards%2C%20professional%20business%20environment%2C%20natural%20lighting%2C%20creative%20workspace%20with%20charts%20and%20graphs%20on%20walls&width=600&height=500&seq=story-image&orientation=portrait"
              alt="Our team workspace"
              className="rounded-2xl shadow-lg object-cover w-full h-96"
            />
            <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-6 rounded-xl shadow-lg">
              <div className="text-3xl font-bold">$50M+</div>
              <div className="text-blue-200">Revenue Generated</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}